import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../../../common/helpers/helpers";
import { DOC_URL } from "../../constants";

const DEFAULT_VERSION = "2.1";

const GnomadVersion = ({ version }) => {
  if (version.startsWith(DEFAULT_VERSION)) {
    return (
      <a
        href={getVarsoUrl(DOC_URL)}
        target="_blank"
        data-testid="gnomad-version"
      >
        <small>{`Version: ${version}`}</small>
      </a>
    );
  }
  return <small data-testid="gnomad-version">{`Version: ${version}`}</small>;
};

GnomadVersion.displayName = "GnomadUrl";

GnomadVersion.propTypes = {
  version: PropTypes.string.isRequired,
};

export default GnomadVersion;
